import api from './api';

const v2VaultProcessService = {
  // Lists one folder level at a time (folders + files) to keep the response small.
  // `prefix` is a folder path relative to the vault root; `nextToken` pages files within a folder.
  listUploadedFiles: async (v2_vault_id, { prefix = '', nextToken = null } = {}) => {
    const params = {};
    if (prefix) params.prefix = prefix;
    if (nextToken) params.nextToken = nextToken;
    const response = await api.get(`/vault/${v2_vault_id}/files`, { params });
    return response.data;
  },
  getFileDownloadUrl: async (v2_vault_id, key) => {
    const response = await api.get(`/vault/${v2_vault_id}/files/download`, { params: { key } });
    return response.data;
  },
  processVault: async (v2_vault_id) => {
    const response = await api.post('/v2-vault-process', { v2_vault_id });
    return response.data;
  },
  reprocessVault: async (v2_vault_id) => {
    const response = await api.post('/v2-vault-process', { v2_vault_id, reprocess: true });
    return response.data;
  },
  reprocessSkipExtraction: async (v2_vault_id) => {
    const response = await api.post('/v2-vault-process', { v2_vault_id, reprocess_skip_extraction: true });
    return response.data;
  },
  reprocessPdfsOnly: async (v2_vault_id) => {
    const response = await api.post('/v2-vault-process', { v2_vault_id, reprocess_pdfs_only: true });
    return response.data;
  },
  // Rebuild the materialised_view_* tables only — one Athena CTAS over data already in the processed
  // bucket. Nothing is re-uploaded, re-encrypted or re-extracted, so this is minutes rather than the
  // 40+ of a full reprocess. Returns as soon as the build is queued; it runs asynchronously.
  rebuildDerivedTables: async (v2_vault_id) => {
    const response = await api.post('/v2-vault-process', { v2_vault_id, rebuild_views: true });
    return response.data;
  }
};

export default v2VaultProcessService;
